import { RouterModule, Routes } from '@angular/router'
import { ExternalLayoutComponent } from './external-layout/external-layout.component' 
import { InternalComponent } from './internal-layout/internal.component'
import { PreviewReferenceMaterialsComponent } from './content-management/components/reference-materials/preview/preview-reference-materials.component'
import { EAppBeneficiaryModule } from '../app/e-app-beneficiary/e-app-beneficiary.module'
import { EAppBeneficiaryComponent } from '../app/e-app-beneficiary/component/EAppBeneficiary.component'
import { CanActivateGaurd } from '../app/auth/can-activate-gaurd' 
// import {SOAViewEmailComponent} from '../app/electronic-soa/components/soa-view-email.component'
import {ESOAFormComponent} from '../app/electronic-soa/components/ESOAFormComponent'
import {ESOAFormViewAgentSignedComponent} from '../app/electronic-soa/components/ESOAFormViewAgentSignedComponent'
import {ESOAFormReturnToAgentComponent} from '../app/electronic-soa/components/ESOAFormReturnToAgentComponent'
import {ESOAFormExpiredComponent} from '../app/electronic-soa/components/ESOAFormExpiredComponent'
import { ElectrronicSOAModule } from '../app/electronic-soa/electronic-soa.modules'
import {ContactUsComponent} from '../app/contact/components/contact-us.component'
import {ContactusModule} from '../app/contact/contact.module'
export const appRoutes: Routes = [
    { 
        path: 'enrollment/e-application/verify-application/:{guid}',
        component: EAppBeneficiaryComponent,
        children: [
            {
                path: '',
                loadChildren: () => import('./e-app-beneficiary/e-app-beneficiary.module').then(m => m.EAppBeneficiaryModule)
            }]
    },

    {
        
        path: 'electronic-soa/viewsoaemailform/:{accessCode}',
        component: ESOAFormComponent,
        children: [
        {
            path: '',
            loadChildren: () => import('./electronic-soa/electronic-soa.modules').then(m => m.ElectrronicSOAModule)
        }]
    },
    {

        path: 'electronic-soa/soaformagentsigned',
        component: ESOAFormViewAgentSignedComponent,
        children: [
            {
                path: '',
                loadChildren: () => import('./electronic-soa/electronic-soa.modules').then(m => m.ElectrronicSOAModule)
            }]
    },
    {

        path: 'electronic-soa/soaviewagentconf',
        component: ESOAFormReturnToAgentComponent,
        children: [
            {
                path: '',
                loadChildren: () => import('./electronic-soa/electronic-soa.modules').then(m => m.ElectrronicSOAModule)
            }]
    },
    {

        path: 'electronic-soa/soaformagentexpired',
        component: ESOAFormExpiredComponent,
        children: [
            {
                path: '',
                loadChildren: () => import('./electronic-soa/electronic-soa.modules').then(m => m.ElectrronicSOAModule)
            }]
    },

    //{

    //    path: 'contact-us/ContactUS/:{insCo}',
    //    component: ContactUsComponent,
    //    children: [
    //        {
    //            path: '',
    //            loadChildren: './contact/contact.module#ContactusModule'
    //        }]
    //},


    //{
    //    path: 'reports',
    //    loadChildren: './reports/reports.module#ReportsModule'
    //},
    //{
    //path: 'enrollment',
    //canActivate: [CanActivateGaurd],
    //loadChildren: '../app/enrollment/enrollment.module#EnrollmentModule'
    //},
    {
        path: 'ssi',
        component: InternalComponent,
        children: [
            {
                path: '',
                loadChildren: () => import('./internal-layout/internal.module').then(m => m.InternalModule)
            }]
    },
    {
        path: 'neje',
        component: InternalComponent,
        children: [
            {
                path: '',
                loadChildren: () => import('./internal-layout/internal.module').then(m => m.InternalModule)
            }]
    },
    {
        path: '',        
        component: InternalComponent,
        children: [
            {
            path: '',
            loadChildren: () => import('./internal-layout/internal.module').then(m => m.InternalModule)
        }]
    } 
]
